<template>
  <v-select
    v-model="selected"
    :items="items"
    item-text="name"
    item-value="id"
    :label="label"
    multiple
    @input="updateSelected"
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item.name }}</span>
      </v-chip>
      <span v-if="index === 1" class="grey--text caption">(+{{ selected.length - 1 }} {{ $t('components.MultiSelect.others') }})</span>
    </template>
  </v-select>
</template>

<script>
export default {
  data () {
    return {
      selected: []
    }
  },
  methods: {
    updateSelected: function () {
      this.$emit('input', this.selected)
    }
  },
  computed: {
    selectedAll () {
      return this.selected.length === this.items.length
    },
    selectedSome () {
      return this.selected.length > 0 && !this.selectedAll
    },
    icon () {
      if (this.selectedAll) return 'mdi-close-box'
      if (this.selectedSome) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  watch: {
    'value': {
      immediate: true,
      handler: function (newValue) {
        if (newValue !== this.selected) {
          this.selected = newValue
        }
      }
    }
  },
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    items: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
}
</script>
